import { gql } from "@apollo/client";

export const TOUR_CATALOG_DOCUMENT_FIELDS = `
  id
  documentType
  name
  normalizedName
  countryCode
  countryName
  aliases
  canonicalKeys
  providerReferences {
    providerCode
    destinationCode
  }
  providerCode
  code
  synchronizedAtUtc
`;

export const GET_TOUR_CATALOG_STATE = gql`
  query GetTourDestinationCatalogState {
    tourDestinationCatalogState {
      id
      indexName
      synchronizedAtUtc
      destinationCount
      languageCount
      currencyCount
      providerCodes
    }
  }
`;

export const GET_TOUR_CATALOG_PAGE = gql`
  query GetTourDestinationCatalog(
    $term: String
    $documentType: TourDestinationCatalogDocumentType!
    $countryCode: String
    $providerCode: String
    $cursor: String
    $pageSize: Int!
  ) {
    tourDestinationCatalog(
      term: $term
      documentType: $documentType
      countryCode: $countryCode
      providerCode: $providerCode
      cursor: $cursor
      pageSize: $pageSize
    ) {
      pageSize
      hasMore
      nextCursor
      items {
        ${TOUR_CATALOG_DOCUMENT_FIELDS}
      }
    }
  }
`;

export const GET_TOUR_CATALOG_DOCUMENT = gql`
  query GetTourDestinationCatalogDocument($id: String!) {
    tourDestinationCatalogDocument(id: $id) {
      ${TOUR_CATALOG_DOCUMENT_FIELDS}
      searchText
    }
  }
`;
